import { render } from "./TradeQuoteHasTraded.vue?vue&type=template&id=0b6422ff&scoped=true"
import script from "./TradeQuoteHasTraded.vue?vue&type=script&lang=js"
export * from "./TradeQuoteHasTraded.vue?vue&type=script&lang=js"

import "./TradeQuoteHasTraded.vue?vue&type=style&index=0&id=0b6422ff&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6422ff"]])

export default __exports__